export const taskable_type_person = 'people.person';
